import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children, roles }) {
  const { user } = useAuth();
  const location = useLocation();

  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50" data-testid="auth-checking">
        <div className="h-8 w-8 rounded-full border-2 border-slate-300 border-t-[#0A2540] animate-spin" />
      </div>
    );
  }
  if (user === false) {
    return <Navigate to="/auth?tab=login" replace state={LOGIN_STATE(location.pathname)} />;
  }
  if (roles && roles.length && !roles.includes(user.role)) {
    return <Navigate to="/dashboard" replace />;
  }
  return children;
}

const LOGIN_STATE = (from) => ({ from });
